module.exports = __webpack_public_path__ + "img/countesse_perverse_mobile.8e924220.jpg";